import InputTypes from '../../../core/enums/InputTypes';
//TODO: campo Parecer
const inputsAnaliseMetodologica = [
    {
        name: 'orgao',
        label: 'Órgão/Entidade',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'proposta.orgao.descOrgao' },
        export: { use: true, nameUse: 'proposta.orgao.descOrgao' },
        filter: { use: true, nameUse: 'proposta.orgao.idenOrgao' },
    },
    {
        name: 'numrVersao',
        label: 'Versão',
        type: InputTypes.DOUBLE,
        table: { use: true, nameUse: 'proposta.numrVersao' },
        export: { use: true },
    },
    {
        name: 'tipoProposta',
        label: 'Tipo de Proposta',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'proposta.tipoProposta.descTipoProposta' },
        export: { use: true, nameUse: 'proposta.tipoProposta.descTipoProposta' },
    },
    {
        name: 'numeroProposta',
        label: 'Nº da Proposta',
        type: InputTypes.INTEGER,
        filter: { use: true, nameUse: 'proposta.id' },
        table: { use: true, nameUse: 'proposta.id' },
        export: { use: true, nameUse: 'proposta.id' },
    },
    {
        name: 'nomeIndicador',
        label: 'Nome do Indicador',
        type: InputTypes.STRING,
        table: { use: true, nameUse: 'proposta.nmIndicador' },
        filter: { use: true, nameUse: 'proposta.nmIndicador' },
        export: { use: true, nameUse: 'proposta.nmIndicador' },
    },
    {
        name: 'usuarioCadastroTable',
        label: 'Resp. Cadastro',
        type: InputTypes.STRING,
        table: { use: true, nameUse: 'contaAcessoCadastro.nome' },
    },
    {
        name: 'usuarioCadastro',
        label: 'Usuário de Cadatro da Proposta',
        type: InputTypes.STRING,
        filter: { use: true, nameUse: 'contaAcessoCadastro.nome' },
    },
    {
        name: 'analistaMetodologica',
        label: 'Análista Metodológico',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'responsavelAnalise.nomePessoa' },
        export: { use: true, nameUse: 'responsavelAnalise.nomePessoa' },
        filter: { use: true, nameUse: 'responsavelAnalise.idenPessoa' },
    },
    {
        name: 'situacaoAnalise',
        label: 'Situação da Análise',
        type: InputTypes.ENTITY,
        table: { use: true, nameUse: 'situacaoAvaliacao.descSituacaoAvaliacao' },
        export: { use: true, nameUse: 'situacaoAvaliacao.descSituacaoAvaliacao' },
        filter: { use: true, nameUse: 'situacaoAvaliacao.id' },
    },
    {
        name: 'parecer',
        label: 'Parecer Metodológico',
        type: InputTypes.ENTITY,
        filter: {
            use: true,
            nameUse:
                'validacaoMetodologica.tipoValidacaoMetodologica.codgTipoValidacaoMetodologica',
        },
    },
    {
        name: 'parecerTable',
        label: 'Parecer',
        type: InputTypes.ENTITY,
        table: {
            use: true,
            nameUse:
                'validacaoMetodologica.tipoValidacaoMetodologica.descTipoValidacaoMetodologica',
        },
        export: {
            use: true,
            nameUse:
                'validacaoMetodologica.tipoValidacaoMetodologica.descTipoValidacaoMetodologica',
        },
    },
];

export default inputsAnaliseMetodologica;
